var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-wrapper"},[_c('select',_vm._b({staticClass:"select",on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'select',_vm.$attrs,false),[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }